import { ReactNode } from 'react';
import styled from 'styled-components';

import { variableFontRegular } from 'styles/theme';

export interface IWindowItemTwoColumnsProps {
  display?: ReactNode;
  title: string;
  titleStyle?: { [key: string]: string };
  onClick?: () => void;
}

export const WindowItemTwoColumns = ({
  display,
  title,
  titleStyle,
  onClick,
}: IWindowItemTwoColumnsProps) => {
  return (
    <WindowItemTwoColumns.Wrapper onClick={onClick}>
      <WindowItemTwoColumns.Title
        data-qa={`${title}_condition`.toLowerCase().replace(/ /g, '_')}
        style={titleStyle}
      >
        {title}
      </WindowItemTwoColumns.Title>
      {display}
    </WindowItemTwoColumns.Wrapper>
  );
};

WindowItemTwoColumns.Wrapper = styled.div<{ isPriceOption?: boolean }>`
  align-items: flex-start;
  border-bottom: ${({ theme }) => theme.borders.black};
  display: flex;
  flex-direction: row;
  padding: 16px;
  text-transform: capitalize;
  cursor: pointer;

  @media (max-width: ${({ theme }) => theme.breakpoints.small - 1}px) {
    ${variableFontRegular({ height: '14px', size: '11.5px' })}
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.small}px) {
    ${variableFontRegular({ height: '14px', size: '11.5px' })}
  }
`;

WindowItemTwoColumns.Title = styled.span<{ isPriceOption?: boolean }>`
  margin-right: 16px;
  min-width: 96px;
`;
